<div
    [ngClass]="{ selected: selected?.ContractId === contract.ContractId }"
    (click)="selectContract(contract)"
    class="edp-card-contract card h-100"
>
    <div class="card-body d-flex flex-row">
        <div class="card-icon d-flex">
            <span class="icon-top">
                <i class="icon {{ type.iconBop }}" [ngClass]="{ disabled: contract.Status === ContractStatusEnum.INACTIVE }"  aria-hidden="true"></i>
            </span>
            <span *ngIf="contract.EmployeeBenefit" class="icon-bottom mb-4">
                <i class="icon-edponline-Bra-134"  aria-hidden="true"></i>
            </span>
        </div>
        <div class="card-body-content d-flex flex-column">
            <div>
                <span class="card-title" [title]="contract.Nickname">{{ contract.Nickname }}</span>
                <span class="card-title-address">{{ fullAddress | titlecase }}</span>
            </div>
            <div class="d-flex flex-row card-footer-content">
                <div class="d-flex flex-row card-alerts">
                    <i class="icon-edponline-Bop-030"  aria-hidden="true" *ngIf="!!alerts"></i>
                    <span *ngIf="!!alerts">{{ alerts }} {{alerts > 1 ? "pt.edp.edponline.contract.details.alerts" : "pt.edp.edponline.contract.details.alert" | translate}}</span>
                </div>

                <ng-container *ngIf="contract.IsManaged">
                    <span class="card-title-local" [ngClass]="{'full-width': !alerts}"
                        *edpConditionalRegion="'pt.edp.edponline.contract.managedby'">
                        <i class="icon-edponline-Bop-061" aria-hidden="true"></i>
                        <span *ngIf="!contract.IsManagedByMe">
                            {{ "pt.edp.edponline.contract.managedby" | translate }}
                            <b>
                                {{ contract.IsManagedBy?.firstName | titlecase }} {{ contract.IsManagedBy?.lastName | titlecase }}
                            </b>
                        </span>
                        <span *ngIf="contract.IsManagedByMe">
                            {{ "pt.edp.edponline.contract.managing" | translate }}
                            <b>
                                {{ contract.CustomerFirstName | titlecase }} {{ contract.CustomerLastName | titlecase }}
                            </b>
                        </span>
                    </span>
                </ng-container>
            </div>
        </div>
    </div>
</div>
